<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/got.png">
                </div>
            </div>

            <!-- <div class="px-8 px-md-16" *ngIf = "showGates === true">
                <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
                <mat-form-field appearance="outline" class="mr-8" fxFlex = "1 1 100%">
                    <mat-select [(ngModel)]="currentGate" placeholder="{{'TOOLBAR.GATE' | translate}}" (selectionChange)="gateChange($event)" required>
                        <mat-option *ngFor="let gate of gates" [value]="gate" >
                            {{gate.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->
            <div class="px-8 px-md-16 gate-pill-wrap" *ngIf = "showGates === true">
                <button mat-button type="button" class="gate-pill" [matMenuTriggerFor]="gateMenu"
                        [matTooltip]="'TOOLBAR.GATE' | translate" [attr.aria-label]="'TOOLBAR.GATE' | translate">
                    <mat-icon class="gate-pill__icon">meeting_room</mat-icon>
                    <span class="gate-pill__text">{{ currentGate?.text || ('TOOLBAR.GATE' | translate) }}</span>
                    <mat-icon class="gate-pill__chevron">arrow_drop_down</mat-icon>
                </button>
                <mat-menu #gateMenu="matMenu" class="gate-pill-menu" xPosition="after">
                    <button mat-menu-item *ngFor="let gate of gates" (click)="selectGate(gate)"
                            [class.gate-pill-menu__active]="gate.value === currentGate?.value">
                        <mat-icon>{{ gate.value === currentGate?.value ? 'check' : 'meeting_room' }}</mat-icon>
                        <span>{{ gate.text }}</span>
                    </button>
                </mat-menu>
            </div>

            <div class="px-8 px-md-16" *ngIf = "showDeskAttendants === true">
                <!-- <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts> -->
                <mat-form-field appearance="outline" class="mr-8" fxFlex = "1 1 100%">
                    <mat-select [(ngModel)]="currentDeskAttendant" placeholder="{{'TOOLBAR.DESK_ATTENDANT' | translate}}" (selectionChange)="deskAttendantChange($event)" required>
                        <mat-option *ngFor="let desk of deskAttendants" [value]="desk" >
                            {{desk.text}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="last-entry-card" *ngIf="lastEntry"
                 [class.last-entry-card--granted]="lastEntry.description === 'Access granted'"
                 [class.last-entry-card--denied]="lastEntry.description !== 'Access granted'"
                 [class.is-new]="newEntry">

                <img class="last-entry-card__photo" (click)="retrivePhoto()"
                     matTooltip="View Photo" [matTooltipPosition]="'right'" [src]="lastEntryPhoto">

                <div class="last-entry-card__main">
                    <span class="last-entry-card__overline">
                        {{ 'TOOLBAR.LENTRY' | translate }}<ng-container *ngIf="lastEntry.door_name"> · {{ lastEntry.door_name }}</ng-container>
                    </span>
                    <span class="last-entry-card__title" [matTooltip]="lastEntry.user_name">
                        {{ lastEntry.user_name }}<ng-container *ngIf="lastEntry.card_label"> · Card {{ lastEntry.card_label }}</ng-container>
                    </span>
                </div>

                <div class="last-entry-status" [matTooltip]="lastEntry.description">
                    <mat-icon class="last-entry-status__icon">{{ lastEntry.description === 'Access granted' ? 'check_circle' : 'cancel' }}</mat-icon>
                    <span class="last-entry-status__text">{{ lastEntry.description }}</span>
                </div>

                <div class="last-entry-card__when" *ngIf="lastEntry.car || lastEntry.date">
                    <span *ngIf="lastEntry.car" class="last-entry-card__car">{{ lastEntry.car }}</span>
                    <span class="last-entry-card__date">{{ lastEntry.date }}</span>
                </div>
            </div>
        </div>

        <div fxLayout="column" class="h3 accent-color-time" fxLayoutAlign="none" >
            <div class="lineHeight">{{currentDate}}</div>
            <div>{{currentTime | async }}</div>
        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-button [matMenuTriggerFor]="userMenu"
                    class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img [src]="photo | safeHtml" *ngIf="photo != null" class="avatar mr-0 mr-sm-16">
                    <img class="avatar mr-0 mr-sm-16" *ngIf="photo == null" src="assets/images/avatars/profile.jpg">
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{name}}</span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu">
                
                <button *ngIf="showGates && allow_local_camera"  (click)="setCameraSource()" mat-menu-item class="" style="display: flex; justify-content: center; align-items: center;">
                    <mat-icon>videocam</mat-icon>
                    <span>Local Cameras</span>
                    <label class="switch" style="margin-left: 8px;">
                        <input type="checkbox" [checked]="cameraSource === 'local'" (change)="setCameraSource()">
                        <span class="slider round">
                        <!-- <mat-icon style="display: flex; align-items: center; height: 100%; margin-left: 5px; color: white;">videocam</mat-icon> -->
                        </span>
                    </label>
                </button>

                <button mat-menu-item (click)="changeTheme()">
                    <mat-icon>{{darkTheme ? 'wb_sunny' : 'wb_iridescent'}}</mat-icon>
                    <span *ngIf="!darkTheme">{{ 'NAV.DARK' | translate }}</span>
                    <span *ngIf="darkTheme">{{ 'NAV.LIGHT' | translate }}</span>
                </button>

                <button *ngIf="!showGates" [routerLink]="'/profile'" mat-menu-item>
                    <mat-icon>account_circle</mat-icon>
                    <span>{{ 'NAV.MYPROFILE.TITLE' | translate }}</span>
                </button>

                <button (click)="logout()" mat-menu-item class="">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>{{ 'NAV.LOGOUT.TITLE' | translate }}</span>
                </button>

            </mat-menu>

            <div class="toolbar-separator"></div>

            <!-- <fuse-search-bar (input)="search($event)"></fuse-search-bar> -->

            <div class="toolbar-separator"></div>

            <button mat-button fxHide fxShow.gt-xs
                    class="language-button"
                    [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage?.flag+'.png'">
                    <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu">

                <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
                        <span class="iso">{{lang.title}}</span>
                    </span>
                </button>

            </mat-menu>

            <!-- <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <button mat-icon-button
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    aria-label="Toggle quick panel">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button> -->

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

        </div>

    </div>

</mat-toolbar>